import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import {
  getCountriesDropdown,
  getStatesDropdowns,
  getRegionDropdown,
  getProfessionDropdown,
  getCategoryDropdown,
  get_Date,
} from "../../Utils/commonFunctions";
import {
  getAllParticipansList,
  submitFormData,
} from "../../Utils/adminFunctions";
import dataTableGrid from "../DataTableGrid";

const AdminAddParticipantsAssing = () => {
  const [listParticipants, setListParticipants] = useState([]);
  const { pgID } = useParams();
  let navigate = useNavigate();
  //for dropdowns//
  const [listCountries, setListCountries] = useState([]);
  const [listStates, setListStates] = useState([]);
  const [listProfession, setListProfession] = useState([]);
  const [listRegion, setListRegion] = useState([]);
  const [listCategory, setListCategory] = useState([]);

  ////form input fields///
  const [category, setCategory] = useState([]);
  const [profession, setProfession] = useState([]);
  const [region, setRegion] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [source, setSource] = useState("Public");
  const [desabledBtn, setDesabledBtn] = useState(false);

  const [errorCategory, setErrorCategory] = useState("");
  const [errorProfession, setErrorProfession] = useState("");
  const [errorRegion, setErrorRegion] = useState("");
  const [errorCountry, setErrorCountry] = useState("");
  const [errorState, setErrorState] = useState("");
  const [errorSource, setErrorSource] = useState("");
  useEffect(() => {
    getRegion();
    getCategory();
    manageParticipants();
  }, [category]);
  const getRegion = async () => {
    const response = await getRegionDropdown();
    if (response.status == "success") {
      setListRegion(response.optionItems);
    } else {
      setListRegion([]);
    }
  };
  const getCountries = async (region_id) => {
    const response = await getCountriesDropdown(region_id);
    if (response.status == "success") {
      setListCountries(response.optionItems);
    } else {
      setListCountries([]);
    }
  };
  const getCategory = async () => {
    const response = await getCategoryDropdown();
    if (response.status == "success") {
      setListCategory(response.optionItems);
    } else {
      setListCategory([]);
    }
  };
  const getProfession = async (categoryID) => {
    const response = await getProfessionDropdown(categoryID);
    if (response.status == "success") {
      setListProfession(response.optionItems);
    } else {
      setListProfession([]);
    }
  };

  const getStates = async (countryID) => {
    if (countryID !== "") {
      const response = await getStatesDropdowns(countryID);
      if (response.status == "success") {
        setListStates(response.optionItems);
      } else {
        setListStates([]);
      }
    } else {
      setListStates([]);
    }
  };

  const manageParticipants = async () => {
    let bodyFormData = new FormData();
    bodyFormData.append("category", category);
    bodyFormData.append("profession", profession);
    bodyFormData.append("region", region);
    bodyFormData.append("country", country);
    bodyFormData.append("state", state);
    bodyFormData.append("source", source);
    const response = await getAllParticipansList(bodyFormData);
    if (response.status === "success") {
      setListParticipants(response.data);
      dataTableGrid({
        data_table_id: "#userlist",
        paginate: false,
        scroller: false,
        copy_option: [0, 1, 2, 3, 4, 5, 6],
        csv_option: [0, 1, 2, 3, 4, 5, 6],
        print_option: [0, 1, 2, 3, 4, 5, 6],
        sort_option: [7],
      });
    } else {
      setListParticipants([]);
      toast.error(response, { autoClose: 1500 });
    }
  };
  const handleParticipantsFilter = async () => {
    manageParticipants();
  };
 
  const handleChangeParticipant = (e) => {
    const { name, checked } = e.target;
    if (name === "allselect") {
      let tempUser = listParticipants.map((user) => {
        return { ...user, isChecked: checked };
      });
      setListParticipants(tempUser);
    } else {
      let tempUser = listParticipants.map((user) => {
        return user.participant_id == name
          ? { ...user, isChecked: checked }
          : user;
      });
      setListParticipants(tempUser);
    }
  };
  const handlerAddPartisipants = async () => {
    setDesabledBtn(true);
    const checkedParticipant = [];
    for (let i = 0; i < listParticipants.length; i++) {
      if (listParticipants[i].isChecked === true) {
        checkedParticipant.push(parseInt(listParticipants[i].participant_id));
      }
    }
    if (checkedParticipant.length == 0) {
      setDesabledBtn(false);
      toast.warning("Please select at least one checkbox.", {
        autoClose: 1500,
      });
      return false;
    } else {
      const bodyFormData = new FormData();
      bodyFormData.append("participant_group_id", pgID);
      bodyFormData.append("partisipants", checkedParticipant);
      const response = await submitFormData(
        "AssingParticipantsTogroup",
        bodyFormData
      );
      if (response.status == "success") {
        toast.success(response.message, { autoClose: 1500 });
        setTimeout(() => {
          navigate("/AdminListParticipants/" + pgID);
        }, 5000);
      } else {
        setDesabledBtn(false);
        toast.error(response.message, { autoClose: 3000 });
      }
    }
    
  };
let ClearAllFilters = () => { 
    setCategory([]);
    category.length=0  
    setProfession([]);
    setRegion([]);
    setCountry([]);
    setState([]);
    setSource("Public");
    manageParticipants();
  };
  return (
    <div>
      <div className="wrapper">
        <div>
          
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="card-tools">
                          <div className="col-md-12">
                            <Link
                              to={"/AdminListParticipants/" + pgID}
                              className="btn btn-sm custom-btn-primary"
                            >
                              <i className="fa fa-arrow-left"></i> Back
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-2">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Category<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorCategory ? " is-invalid" : "")
                                }
                                value={category}
                                onChange={(e) => {
                                  getProfession(e.target.value);
                                  setCategory(e.target.value);
                                  setErrorCategory("");
                                }}
                              >
                                <option value="">Select</option>
                                {listCategory}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Specialization<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorProfession ? " is-invalid" : "")
                                }
                                value={profession}
                                onChange={(e) => {
                                  setProfession(e.target.value);
                                  setErrorProfession("");
                                }}
                              >
                                <option value="">Select</option>
                                {listProfession}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Region<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorRegion ? " is-invalid" : "")
                                }
                                value={region}
                                onChange={(e) => {
                                  getCountries(e.target.value);
                                  setRegion(e.target.value);
                                  setErrorRegion("");
                                }}
                              >
                                <option value="">Select</option>
                                {listRegion}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Country<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorCountry ? " is-invalid" : "")
                                }
                                value={country}
                                onChange={(e) => {
                                  getStates(e.target.value);
                                  setCountry(e.target.value);
                                  setErrorCountry("");
                                }}
                              >
                                <option value="">Select</option>
                                {listCountries}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                State<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorState ? " is-invalid" : "")
                                }
                                value={state}
                                onChange={(e) => {
                                  setState(e.target.value);
                                  setErrorState("");
                                }}
                              >
                                <option value="">Select</option>
                                {listStates}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Source<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorSource ? " is-invalid" : "")
                                }
                                value={source}
                                onChange={(e) => {
                                  setSource(e.target.value);
                                  setErrorSource("");
                                }}
                              >
                                <option value="Public">Public</option>
                                <option value="Private">Private</option>
                                <option value="all">All</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              {/* <Link
                                to={"/AdminAddParticipantsAssing/"+ pgID}
                                className="btn btn-sm custom-btn-primary pull-right ms-1"
                               
                              >
                                Clear all
                              </Link>   */}
                            <button
                                type="button"
                                className="btn btn-sm custom-btn-primary pull-right ms-1"
                                onClick={()=> ClearAllFilters()}
                              >
                                Clear all
                              </button>
                            <button
                                type="button"
                                className="btn btn-sm custom-btn-primary pull-right"
                                onClick={handleParticipantsFilter}
                              >
                                Apply Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {listParticipants.length > 0 ? (
                          <div className="col-md-12">
                            <div className="form-group">
                              <button
                                type="button"
                                className="btn btn-sm custom-btn-primary pull-right"
                                onClick={handlerAddPartisipants}
                                disabled={desabledBtn}
                              >
                                Add Participants
                              </button>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      <div className="card-body scroll-doctos">
                        <table
                          id="userlist1"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  name="allselect"
                                  checked={
                                    !listParticipants.some(
                                      (user) => user?.isChecked !== true
                                    )
                                  }
                                  onChange={handleChangeParticipant}
                                />
                              </th>
                              <th>First Name</th>
                              <th>Last Name</th>
                              <th>Email</th>
                              <th>Contact no.</th>
                              <th>Category</th>
                              <th>Specilization</th>
                              <th>Country</th>
                              <th>Source</th>
                              <th>Created date</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {listParticipants.length > 0 ? (
                              listParticipants.map((item, i) => (
                                <tr key={++i}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      name={item.participant_id}
                                      checked={item?.isChecked || false}
                                      onChange={handleChangeParticipant}
                                    />
                                  </td>
                                  <td>{item.first_name}</td>
                                  <td>{item.last_name}</td>
                                  <td>{item.email}</td>
                                  <td>{item.contact}</td>
                                  <td>{item.category_name}</td>
                                  <td>{item.profession_name}</td>
                                  <td>{item.country_name}</td>
                                  <td>{item.source}</td>
                                  <td>{get_Date(item.created_date)}</td>
                                  <td>Approved</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={11} className="text-center">
                                  Result not found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminAddParticipantsAssing;
